//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import topImg from '@/assets/others/shaoxing/gongkuang/wave-top.png';
import midImg from '@/assets/others/shaoxing/gongkuang/wave-mid.png';
import botImg from '@/assets/others/shaoxing/gongkuang/wave-bot.png';
import onImg from '@/assets/others/shaoxing/gongkuang/on.png';
import { queryRealtime } from '@/api/api';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'xijiang',
  mixins: [GetSiteIdMixin],
  props: ['siteId'],
  data: function data() {
    return {
      topImg: topImg,
      midImg: midImg,
      botImg: botImg,
      onImg: onImg,
      processInfo: [],
      switchInfo: [],
      dataMap: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.$bus.$emit('isCheckbox', 'show', false);
    }, 200);
    this.getInfo();
  },
  methods: {
    getInfo: function getInfo() {
      var that = this;
      var params = {
        type: '1',
        id: this.siteId
      }; // 污水站点

      queryRealtime(params).then(function (res) {
        if (res) {
          that.processInfo = res.result.factorMap['12'] || [];
          that.switchInfo = res.result.factorMap['14'] || [];

          if (res.result.records.length > 0) {
            that.dataMap = res.result.records[0].dataMap || null;
          } else {
            that.dataMap = null;
          }
        }
      });
    }
  }
};